module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'UserList'
      }
    }
  }, [_vm._v("Użytkownicy")]), _vm._v("/"), (_vm.item && !_vm.loading) ? _c('span', [_vm._v(_vm._s(_vm.item['name']) + " " + _vm._s(_vm.item['surname']))]) : _vm._e()], 1), _vm._v(" "), (_vm.item && !_vm.loading && !_vm.resetPasswordLoading) ? _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'UserUpdate',
        params: {
          id: _vm.item.id
        }
      },
      "title": "Edytuj"
    }
  }, [_c('span', [_vm._v("Edytuj")]), _c('svg-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "title": "Resetuj hasło"
    },
    on: {
      "click": function($event) {
        return _vm.resetPassword(_vm.item)
      }
    }
  }, [_c('span', [_vm._v("Resetuj hasło")]), _c('svg-icon', {
    attrs: {
      "name": "padlock"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.deleteItem(_vm.item)
      }
    }
  }, [_c('span', [_vm._v("Usuń")]), _c('svg-icon', {
    attrs: {
      "name": "minus"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.resetPasswordShowMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Na adres " + _vm._s(_vm.resetPasswordShowMessage.email) + " został wyłany email z linkiem umożliwiającym ustawienie nowego hasła")]) : _vm._e(), _vm._v(" "), (_vm.loading || _vm.resetPasswordLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.deleteError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.deleteError))]) : _vm._e(), _vm._v(" "), (_vm.item && !_vm.loading && !_vm.resetPasswordLoading) ? _c('div', [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Imię: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['name']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nazwisko: ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['surname']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("E-mail:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item['email']))])])])])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5578ea2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Show.vue
// module id = 840
// module chunks = 0